// T-99: copied from software-factory's shared/list-item-lines.ts (SF-T-265), so jflo writes and reads several-line answers and notes as the factory does. Keep them in step.
/** A note or answer as typed, tidied: \n line ends, no trailing spaces, one blank line at most between paragraphs, trimmed. */
export function tidyLines(text: string): string {
  return text
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => line.trimEnd())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

/**
 * SF-T-265: a note or answer of several lines inside one item of a decisions or answers message (a
 * numbered list). Its first line goes on the item's line; the rest are indented under it by `indent`
 * spaces, so the comment's markdown keeps them in the item and the message's parser can read them back.
 * A blank line between paragraphs stays (one at most), and trailing spaces go.
 */
export function indentFollowingLines(text: string, indent: number): string {
  const pad = ' '.repeat(indent);
  return tidyLines(text)
    .split('\n')
    .map((line, i) => (i === 0 || !line ? line : pad + line))
    .join('\n');
}

const indentOf = (line: string) => line.length - line.trimStart().length;

/**
 * Reads back the lines indentFollowingLines wrote under an item: from `lines[from]`, every line indented
 * by at least `indent` spaces, and a blank line only when one such follows it. `next` is the first line
 * after them. The text has the indent taken off, so its own deeper indentation stays.
 */
export function readFollowingLines(lines: string[], from: number, indent: number): { text: string; next: number } {
  const out: string[] = [];
  let i = from;
  while (i < lines.length) {
    if (!lines[i].trim()) {
      let j = i;
      while (j < lines.length && !lines[j].trim()) j++;
      if (j === lines.length || indentOf(lines[j]) < indent) break;
      out.push('');
      i = j;
      continue;
    }
    if (indentOf(lines[i]) < indent) break;
    out.push(lines[i].slice(indent).trimEnd());
    i++;
  }
  return { text: out.join('\n'), next: i };
}
